import { z } from 'zod'
import dayjs from 'dayjs';
import { SignalMonitoringTypes } from 'applications/signal/constants';

export const NotificationSettingEditFormSchema = z.object({
  signalType: z.number()
    .min(SignalMonitoringTypes.BrandShareRate, "シグナルタイプは必須です")
    .max(SignalMonitoringTypes.CategoryPlummetingItemQuantity, "シグナルタイプの値が不正です"),
  categories: z.array(z.string()).min(1, "カテゴリは1つ以上選択してください"),
  areas: z.array(z.string()).optional(),
  channels: z.array(z.string()).optional(),
  genderAges: z.array(z.string()).optional(),
  shopChains: z.array(z.string()).optional(),
  startDate: z.string().min(1, "開始日は必須です"),
  targetDays: z.preprocess(
    (val) => (typeof val === 'number' ? val.toString() : val),
    z.string()
    .nonempty("累計日数は必須です")
    .refine(
      (val) => /^\d+$/.test(val.toString()),
      { message: "整数で入力してください" }
    )
    .transform(val => Number(val))
    .pipe(
      z.number()
        .min(3, "累計日数は3以上でなければなりません")
        .max(30, "累計日数は30以下でなければなりません")
     ),
  ),
  targetBrand: z.string().min(1, "対象商品は選択必須です"),
  comperetiveBrands: z.array(z.string()).min(1, "競合商品は1つ以上選択してください").max(10, "競合商品は最大10まで選択できます"),
}).refine(
  (data) => !data.comperetiveBrands.includes(data.targetBrand),
  {
    message: "競合ブランドに対象ブランドが含まれています",
    path: ["targetBrand"],
  }
).refine(
  (data) => {
    if (!data.startDate || !data.targetDays) {
      return true; // 他のバリデーションでキャッチされるのでここではスルー
    }
    const start = dayjs(data.startDate);
    const end = dayjs().subtract(1, 'day');
    const gap = end.diff(start, 'day');
    return gap >= data.targetDays + 1;
  },
  {
    message: "開始日は少なくとも1日ずらしで2累計日数分が取れる日付にしてください",
    path: ["startDate"],
  }
);

export type NotificationSettingEditFormData = z.infer<typeof NotificationSettingEditFormSchema>;
